  const triggers = Array.from(document.querySelectorAll('[data-faq-trigger]'));
  triggers.forEach(trigger => {
    trigger.addEventListener('click', (event) => {
        let elem = event.target;
        let method = elem.getAttribute('data-faq-trigger');
        
        const panel = document.querySelectorAll(`[data-faq-panel="${method}"]`);
        
        if (panel[0].parentNode.classList.contains('toggled')) {
            panel[0].parentNode.classList.remove('toggled');
            panel[0].parentNode.removeAttribute("style");
        } else {
            panel[0].parentNode.classList.add('toggled');
            panel[0].parentNode.setAttribute("style", `max-height:${panel[0].offsetHeight + 100}px`);
        }
    });
  });